import { Component } from '@angular/core';

@Component({
  selector: 'renderstatic-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false,
})
export class WelcomeComponent {}
